import { PermissionTemplatesPanel } from '../PermissionTemplatesPanel'

export default function RolesAdminPage() {
  return (
    <div className="space-y-4 max-w-3xl">
      <div>
        <h2 className="text-lg font-bold text-foreground">Roles & Permissions</h2>
        <p className="text-sm text-muted-foreground">
          Manage the default module access each department + role combination starts with.
        </p>
      </div>
      <PermissionTemplatesPanel />
    </div>
  )
}
